import { createReducer } from 'Helpers/redux'
// eslint-disable-next-line no-unused-vars
import {
  GET_TOTAL_PAYMENT_PERIOD,
  GET_FIRST_PAYMENT_PERIOD,
  GET_REPEATED_PAYMENT_PERIOD,
  GET_REQUEST_ACTIVITY,
} from '../actions/analyticsActions'

const initialState = {
  totalPaymentPeriod: {},
  firstPaymentPeriod: {},
  repeatedPaymentPeriod: {},
  requestsActivity: {},
  loading: true,
}

const handlers = {
  [GET_TOTAL_PAYMENT_PERIOD.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    totalPaymentPeriod: payload,
    loading: false,
  }),
  [GET_FIRST_PAYMENT_PERIOD.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    firstPaymentPeriod: payload,
    loading: false,
  }),
  [GET_REPEATED_PAYMENT_PERIOD.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    repeatedPaymentPeriod: payload,
    loading: false,
  }),
  [GET_REQUEST_ACTIVITY.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    requestsActivity: payload,
    loading: false,
  }),
}

export default createReducer(initialState, handlers)
